import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { ConfigProvider } from "antd";
import { DefaultLayout } from "./layouts";

import enLocale from "antd/locale/en_US";
import jpLocale from "antd/locale/ja_JP";
import cnLocale from "antd/locale/zh_CN";
import krLocale from "antd/locale/ko_KR";

const App: React.FC = () => {
  return (
    <ConfigProvider
      locale={
        localStorage.getItem("i18nextLng") === "en"
          ? enLocale
          : localStorage.getItem("i18nextLng") === "jp"
          ? jpLocale
          : localStorage.getItem("i18nextLng") === "cn"
          ? cnLocale
          : krLocale
      }
      theme={{
        token: {
          colorPrimary: "#074799",
          fontFamily: "Plus Jakarta Sans, serif"
        }
      }}
    >
      <BrowserRouter>
        <div className="w-full">
          <Routes>
            <Route path="/*" element={<DefaultLayout />} />
          </Routes>
        </div>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
